import { useTranslation } from 'react-i18next';

export const keyPrefix = 'full_frame';
export const useFullFrameTranslation = () => useTranslation('shared', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    empty: 'Полный кадр отсутствует',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    empty: 'Full frame is missing',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    empty: 'Quadro completo ausente',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    empty: 'Falta el cuadro completo',
  },
}) as Record<string, unknown>;
